






























































import { Component, Mixins } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderGetters } from "@/store/modules/order/types";
import { Order } from "@/models/order/order";
import { Mobile } from "@/mixins/mobile";
import EditMultiplier from "@/components/elements/utility/EditMultiplier.vue";
import MultiplierWarning from "@/components/elements/utility/MultiplierWarning.vue";
@Component({ components: { EditMultiplier, MultiplierWarning } })
export default class OrderSummary extends Mixins(Mobile) {
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrder))
  storeOrder!: Order;

  // NOTE: this component used to clear `created_type` on the cart page. That
  // erased the "duplicated" signal before checkout could read it, so a
  // duplicate's ingested notes got wiped by CheckoutForm's new-quote reset.
  // The flag is frontend-only and reset by `clearOrder` on any new-quote/load,
  // so it is now left in place until then. See CheckoutForm.initializeFromCustomer.

  get surchargeDecimal(): number {
    const num = parseFloat(process.env.VUE_APP_PRICE_SURCHARGE_VALUE_NUMBER || "");
    return !isNaN(num) && num > 0 ? num : 0;
  }

  get surchargeLabel(): string {
    if (this.surchargeDecimal <= 0) return "";
    return `${+(this.surchargeDecimal * 100).toFixed(2)}%`;
  }

  get surchargePercent(): number {
    return this.surchargeDecimal > 0 ? this.surchargeDecimal * 100 : 0;
  }

  get price(): number {
    let price = 0;
    for (const item of this.storeOrder.items!) {
      price += item.qty * (item.unit_price * item.multiplier);
    }
    return price;
  }

  get surchargeAmount(): number {
    if (this.surchargePercent <= 0) return 0;
    return parseFloat((this.price * this.surchargePercent / 100).toFixed(2));
  }

  get totalPrice(): number {
    return this.price + this.surchargeAmount;
  }

  get totalQty(): number {
    let qty = 0;
    if (this.storeOrder.items && this.storeOrder.items.length) {
      for (const item of this.storeOrder.items) {
        qty += item.qty;
      }
    }
    return qty;
  }

  get isReviewPage(): boolean {
    return this.$route.name === "OrderReview";
  }

  /**
   * The cart is where multipliers are edited, so the warning's link is dropped
   * there. Covers the saved-cart route too — same view, same reason.
   */
  get isCartPage(): boolean {
    return this.$route.name === "Cart" || this.$route.name === "SavedCart";
  }
}
